var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"view-error container"},[_c('div',{staticClass:"error-logo"},[_c('img',{attrs:{"src":_vm.Logo}})]),_c('div',{staticClass:"plan-panel only"},[_c('h3',[_vm._v(_vm._s(_vm.t('Error')))]),_c('p',[_vm._v(_vm._s(_vm.t("Could not reach our servers. Are you offline?")))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }